import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import ImageUploadButton from "../ImageUploadButton";
import MyArrayInput from "../MyArrayInput";
import InputMask from "react-input-mask";
import CardPost from "./CardPost";
import PostDetailsScraped from "./PostDetailsScraped";
import { COLORS } from "colors/color";
import { connect } from "react-redux";
import { setUserId } from "../../Redux/actions";
import { Switch, FormControlLabel } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import { Chips } from "primereact/chips";
import { Row, Col, Container } from "react-bootstrap";
import {
  DateField,
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import ChipInput from "components/Chips/chip";
import styled from "styled-components";
import GlobalCityAutocomplete from "components/CitiesPicker/CitiesPicker";
import SalaryInputWithCurrency from "components/Inputs/SalaryInputWithCurrency";
import SkeletonLoaderDemo from "components/Loading/LoadingDemo";
import AnimatedLoading from "components/Loading/aminateLoading";
import ArchiveSwitch from "components/archiveSwich/archiveSwich";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { TitleTypography } from "StyledTypography/StyledTypography";
import { PostSearchBar } from "components/searchBars/SearchBars";
import { SearchButton } from "components/Buttons/Buttons";
import { PostButton } from "components/Buttons/Buttons";
import { useSnackbar } from "hooks/useSbackbar";
import WorkingDetailsDialog from "views/Posts/Dialogs/WorkingDetailsDialog";
import PostDetailsDialog from "views/Posts/Dialogs/PostDetails";
import { useTranslation } from "react-i18next";
import useLinkedInPost from "views/Posts/hooks/LinkedInPost";
import NewSearchBar from "components/searchBars/NewSearchBar";
import searchIcon from "../../assets/img/search_icon_grey.svg";
import addIcon from "../../assets/img/add_icon.svg";
import filterIcon from "../../assets/img/filter_icon.svg";
import JobCardRec from "views/Posts/JobCardRec";
import JobCardRecSkeleton from "views/Posts/components/skeletonPost";
import CustomPagination from "views/client/pagination";
import FilterDialog from "components/Dialog/FilterDialog";

const theme = createTheme();
const apiUrl = process.env.REACT_APP_API_URL;
const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;
const apiUrlsoket = process.env.REACT_APP_API_URL_SOKET;
const WelcomeSection = styled(Paper)(({ theme }) => ({
  padding: "1rem",
  marginBottom: "2rem",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "right",
  backgroundColor: "#fff",
  borderRadius: "16px !important",
  boxShadow: "0 4px 11px rgba(0.1, 0.1, 0.1, 0.2)",
  "&&": {
    borderRadius: "16px",
  },
}));
const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: "6px",
    padding: "16px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
  },
});

const StyledDialogContent = styled(DialogContent)({
  padding: 0,
});
// const StyledSelect = styled(Select)(({ theme }) => ({
//   "& .MuiOutlinedInput-notchedOutline": {
//     borderColor: COLORS.grey,
//   },
//   "&:hover .MuiOutlinedInput-notchedOutline": {
//     borderColor: COLORS.signIn,
//   },
//   "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//     borderColor: COLORS.signIn,
//   },
// }));
const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 6,
  },
}));
const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: "16px",
  "&.MuiChip-outlined": {
    borderColor: COLORS.signIn,
  },
}));
const StyledUploadBox = styled(Box)(({ theme }) => ({
  border: `2px dashed ${theme.palette.grey[400]}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  textAlign: "center",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const StyledPreviewImage = styled("img")({
  maxWidth: "100%",
  maxHeight: "200px",
  objectFit: "contain",
});
const StyledSelect = styled(Select)(({ theme }) => ({
  height: 56,
  fontFamily: "Poppins",
  borderRadius: "10px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#e0e0e0",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
    borderWidth: "2px",
    boxShadow: "0px 0px 5px 0.4px #0085FF",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
    borderWidth: "2px",
    boxShadow: "0px 0px 5px 0.4px #0085FF",
  },

  "& .MuiSelect-select": {
    padding: "16.5px 14px",
  },
}));
const StyledFormControl = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "transparent",
      borderWidth: "2px",
    },
    "&:hover": {
      boxShadow: "0px 0px 5px 0.4px #0085FF",
    },
    "&.Mui-focused": {
      boxShadow: "0px 0px 5px 0.4px #0085FF",
      "& fieldset": {
        borderColor: "transparent",
        borderWidth: "2px",
      },
    },
    "&.Mui-error": {
      "&:hover, &.Mui-focused": {
        boxShadow: "0px 0px 5px 0.4px #d32f2f",
      },
    },
  },
});
const PostPage = () => {
  const [postImage, setPostImage] = useState("");
  const [postTitle, setPostTitle] = useState("");
  const [reference, setReference] = useState("");
  const [accountType, setAccountType] = useState("g");
  const [postDescription, setPostDescription] = useState("");
  const [postRequirement, setPostRequirement] = useState([]);
  const [postDeadline, setPostDeadline] = React.useState(null);
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState("");
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const linkedInPost = useLinkedInPost();
  const [recruiterEmail, setRecruiterEmail] = useState("");
  const [ref] = useState(true);
  const [selectedPost, setSelectedPost] = useState(null);

  const theme = useTheme();
  const apiUrl = process.env.REACT_APP_API_URL;
  const userId = getUserIdFromAccessToken();
  const [errors, setErrors] = useState({});
  const [offerType, setOfferType] = useState("");
  const [location, setLocation] = useState(null);
  const [numPeople, setNumPeople] = useState(null);
  const [salary, setSalary] = useState(null);
  const [isCheckedScr, setIsCheckedScr] = useState(true);
  const [workingMode, setWorkingMode] = useState("");
  const [showAllPosts, setShowAllPosts] = useState(false);
  const [currency, setCurrency] = useState("MAD");
  const client_id = "86dpwd87p8nanb";
  const secret_id = process.env.LINKEDIN_CLIENT_SECRET;
  const [loading, setLoading] = useState(true);
  const [postId, setPostId] = useState();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [totalPosts, setTotalPosts] = useState(0);
  const [fieldOfStudy, setFieldOfStudy] = useState("");
  const [otherFieldOfStudy, setOtherFieldOfStudy] = useState("");
  const [experience, setExperience] = useState("");
  const [diploma, setDiploma] = useState("");
  const [otherDiploma, setOtherDiploma] = useState("");
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [filterOptions, setFilterOptions] = useState({ quiz: false });
  const { t } = useTranslation();

  useEffect(() => {
    console.log('posts--:', posts)
  }, [posts])
  const handleDateChange = (newValue) => {
    const dateOnly = newValue ? dayjs(newValue).format("YYYY-MM-DD") : null;
    setPostDeadline(dateOnly);
    console.log(postDeadline);
  };
  const convertOfferType = (type) => {
    return type === "internship" ? "i" : "j";
  };
  const validateFirstDialog = () => {
    let tempErrors = {};
    tempErrors.postTitle = postTitle ? "" : t("postPage.errors.postTitle");
    tempErrors.reference = reference ? "" : "Reference is required";
    tempErrors.accountType = accountType ? "" : "accountType is required";
    tempErrors.postDescription = postDescription
      ? ""
      : "Post description is required";
    tempErrors.postRequirement =
      postRequirement.length > 0 ? "" : "At least one requirement is required";
    tempErrors.postDeadline = postDeadline ? "" : "Deadline is required";
    tempErrors.offerType = offerType ? "" : "Offer type is required";
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const validateSecondDialog = () => {
    let tempErrors = {};
    tempErrors.location = location ? "" : "Location is required";
    tempErrors.workingMode = workingMode ? "" : "Working mode is required";
    tempErrors.postImage = postImage ? "" : "Image is required";

    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };
  const handleNext = () => {
    if (validateFirstDialog()) {
      console.log("test");
      setOpen(false);
      setOpen2(true);
    }
  };

  const handlePostClick = (post) => {
    const encodedId = btoa(post.id);
    navigate(`/talent/post/scraped/${encodedId}`);
    localStorage.setItem("currentPostId", encodedId);
  };

  const handleSave = () => {
    if (validateSecondDialog()) {
      save();
    }
  };
  useEffect(() => {
    console.log("clientid is : ", client_id);
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    console.log("test2");
    if (code) {
      console.log("The URL contains the code:", code);
      fetchCallbackData(code);
    } else {
      console.log("Code not found in the URL.");
    }
  }, []);

  const handleLinkedInAuth = () => {
    const client_id = "86dpwd87p8nanb";
    const redirectUri = encodeURIComponent(
      `${window.location.origin}/talent/post/PostDetails/`
    );
    const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${client_id}&redirect_uri=${redirectUri}&scope=openid%20email%20profile%20w_member_social`;

    // Open LinkedIn auth in a new tab
    const newWindow = window.open(linkedInAuthUrl, "_blank");

    // Set up a listener for messages from the new window
    window.addEventListener("message", handleAuthMessage, false);

    // Function to handle the message from the new window
    function handleAuthMessage(event) {
      if (event.origin !== window.location.origin) return;

      const { code } = event.data;
      if (code) {
        console.log("Received code from LinkedIn auth:", code);
        // fetchCallbackData(code);
        window.removeEventListener("message", handleAuthMessage);
        newWindow.close();
      }
    }
  };

  const fetchCallbackData = async (code) => {
    console.log("Code:", code);
    try {
      const response = await axios.get(
        `${apiUrl}authentication/linkedin_callback_post/`,
        {
          params: { code: code },
        }
      );
      console.log("LinkedIn token response:", response.data);
      localStorage.setItem(
        "accessToken_LinkedIn",
        response.data.linkedIn_access_token
      );
      localStorage.setItem(
        "linkedin_person_id",
        response.data.linkedin_person_id
      );
      handleCreatePost(
        response.data.linkedIn_access_token,
        response.data.linkedin_person_id
      );
      resetForm();
    } catch (error) {
      console.error("Error fetching data from callback:", error);
    }
  };
  useEffect(() => {
    console.log("test1");
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    console.log("test2");
    if (code) {
      console.log("The URL contains the code:", code);
      fetchCallbackData(code);
    } else {
      console.log("Code not found in the URL.");
    }
  }, []);
  useEffect(() => {
    Load();
    console.log("user id is :", userId);
  }, []);
  useEffect(() => {
    Load();
  }, [showAllPosts]);
  useEffect(() => {
    console.log("Loading", loading);
  }, [loading]);
  const handleCreatePost = async (token, personnalId) => {
    const formData = JSON.parse(localStorage.getItem("postFormData"));
    console.error("Form data: ", formData);
    if (!formData) {
      console.error("Form data not found in localStorage");
      return;
    }

    const {
      postImage,
      postTitle,
      reference,
      postDescription,
      postRequirement,
      postDeadline,
      location,
      numPeople,
      workingMode,
      salary,
      currency,
      offerType,
      postId,
      recruiterEmail
    } = formData;

    if (
      !postTitle ||
      !reference ||
      !postDeadline ||
      !location ||
      !postDescription ||
      !postRequirement ||
      !postId
    ) {
      console.error("Missing required fields");
      toast.error("Missing required fields");
      return;
    }

    try {
      const response = await axios.post(
        `${apiUrl}authentication/linkedin/post-create/`,
        {
          token: token,
          personnalId: personnalId,
          subject: postTitle,
          Reference: reference,
          lien: `${apiUrlFront}viewjob/${postId}`,
          postDeadline: postDeadline,
          location: location,
          postImage: postImage,
          postDescription: postDescription,
          requirement: postRequirement,
          workMode: workingMode,
          salary: salary || null,
          numToHire: numPeople || null,
          currency: currency,
          education: `${diploma || otherDiploma} ${fieldOfStudy || otherFieldOfStudy
            }`,
          experiences: experience,
          recruiter_email: recruiterEmail
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      console.log(response.data);
      toast.success("Post created and shared on LinkedIn successfully!");

      // Reset form and clear localStorage
      resetForm();
      localStorage.removeItem("linkedin_person_id");
      localStorage.removeItem("accessToken_LinkedIn");
      localStorage.removeItem("postFormData");

      if (window.opener) {
        window.opener.postMessage(
          { action: "postCreated" },
          window.location.origin
        );
        window.close();
      }
    } catch (error) {
      console.error("Error creating post:", error);
      toast.error("Failed to create post on LinkedIn");
    }
  };
  useEffect(() => {
    console.log("apiUrlFront", apiUrlFront);
    window.addEventListener("message", handlePostCreatedMessage);
    return () => {
      window.removeEventListener("message", handlePostCreatedMessage);
    };
  }, []);
  const handlePostCreatedMessage = (event) => {
    if (event.origin !== window.location.origin) return;
    if (event.data.action === "postCreated") {
      // Refresh the post list or update state as needed
      Load();
      // Show a success message to the user
      toast.success("Post created and shared on LinkedIn successfully!");
    }
  };
  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      const userId = decodedToken.user_id; // Adjust according to your JWT payload structure
      return userId;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }
  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    //console.log("payload : ", jsonPayload);

    return JSON.parse(jsonPayload);
  }
  useEffect(() => {
    console.log('posts is : ', posts)
  }, [])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoading(true);
    // Fetch new page data
    const fetchPage = async () => {
      try {
        const endpoint = showAllPosts
          ? `${apiUrl}posts/listScraped/${userId}/all/`
          : `${apiUrl}posts/listScraped/${userId}/`;
        const response = await fetch(`${endpoint}?page=${newPage + 1}&page_size=${rowsPerPage}`, {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        });
        if (response.ok) {
          const data = await response.json();
          setPosts(data.results);
          setTotalPosts(data.count);
        }
      } catch (error) {
        console.error("Error fetching page:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setLoading(true);
    // Fetch first page with new page size
    const fetchNewPageSize = async () => {
      try {
        const endpoint = showAllPosts
          ? `${apiUrl}posts/listScraped/${userId}/all/`
          : `${apiUrl}posts/listScraped/${userId}/`;
        const response = await fetch(`${endpoint}?page=1&page_size=${newRowsPerPage}`, {
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        });
        if (response.ok) {
          const data = await response.json();
          setPosts(data.results);
          setTotalPosts(data.count);
        }
      } catch (error) {
        console.error("Error fetching with new page size:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNewPageSize();
  };

  // Add useEffect to reload data when page, rowsPerPage or quiz filter changes
  useEffect(() => {
    Load();
  }, [page, rowsPerPage, showAllPosts, filterOptions.quiz]);

  async function Load() {
    try {
      setLoading(true);
      const endpoint = showAllPosts
        ? `${apiUrl}posts/listScraped/${userId}/all/`
        : `${apiUrl}posts/listScraped/${userId}/`;

      let url = `${endpoint}?page=${page + 1}&page_size=${rowsPerPage}`;
      if (filterOptions.quiz) {
        url += `&quiz=true`;
      }

      const response = await fetch(url, {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });
      if (response.status === 401) {
        // Handle unauthorized access
        return;
      }
      const json = await response.json();
      setPosts(json.results);
      setTotalPosts(json.count);
      setLoading(false);
      console.log('Loaded data:', json);
    } catch (error) {
      console.error("Error loading data:", error);
      setLoading(false);
    }
  }
  // const navigate =useNavigate();
  // const handlePostClick = (post) => {
  //   const encodedId = btoa(post.id);
  //   navigate(`/talent/post/${encodedId}`);
  // };
  async function save() {
    setOpen2(false);
    const formData = {
      postImage,
      postTitle,
      reference,
      accountType,
      postDescription,
      postRequirement,
      postDeadline,
      location,
      workingMode,
      currency,
      offerType,
      recruiterEmail
    };

    try {
      setLoading(true);
      console.log("Sending data to server:", {
        image: postImage,
        title: postTitle,
        reference: reference,
        accountType: accountType,
        description: postDescription,
        requirements: postRequirement,
        deadline: postDeadline,
        recruiter: userId,
        mode: workingMode,
        salary: salary,
        age_experience: numPeople,
        scraped: isCheckedScr,
        currency: currency,
        localisation: location,
        offerType: convertOfferType(offerType),
        education: `${diploma || otherDiploma} ${fieldOfStudy || otherFieldOfStudy
          }`,
        experiences: experience,
        recruiter_email: recruiterEmail
      });

      const response = await axios.post(`${apiUrl}posts/create/`, {
        image: postImage,
        title: postTitle,
        reference: reference,
        accountType: accountType,
        description: postDescription,
        requirements: postRequirement,
        deadline: postDeadline,
        recruiter: userId,
        mode: workingMode,
        salary: salary || null,
        age_experience: numPeople || null,
        scraped: isCheckedScr,
        currency: currency,
        localisation: location,
        offerType: convertOfferType(offerType),
        education: `${diploma || otherDiploma} ${fieldOfStudy || otherFieldOfStudy
          }`,
        experiences: experience,
        recruiter_email: recruiterEmail
      });

      console.log("Server response:", response.data);

      const newPostId = response.data.id;
      setPostId(newPostId);

      // Update formData with the new postId
      formData.postId = btoa(newPostId);
      if (isChecked) {
        linkedInPost.handleLinkedInAuth(formData);
        // localStorage.setItem("postFormData", JSON.stringify(formData));
        // if (
        //   !localStorage.getItem("linkedin_person_id") ||
        //   !localStorage.getItem("accessToken_LinkedIn")
        // ) {
        //   handleLinkedInAuth();
        // } else {
        //   handleCreatePost(
        //     localStorage.getItem("accessToken_LinkedIn"),
        //     localStorage.getItem("linkedin_person_id")
        //   );
        // }
      }

      setLoading(false);
      resetForm();
      Load();
      toast.success("Post created successfully!");
    } catch (err) {
      setLoading(false);
      console.error("Post Registration Failed:", err);
      if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error("Error response data:", err.response.data);
        console.error("Error response status:", err.response.status);
        console.error("Error response headers:", err.response.headers);
        toast.error(
          `Post Registration Failed: ${err.response.data.message || err.response.statusText
          }`
        );
      } else if (err.request) {
        // The request was made but no response was received
        console.error("Error request:", err.request);
        toast.error(
          "Post Registration Failed: No response received from server"
        );
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error message:", err.message);
        toast.error(`Post Registration Failed: ${err.message}`);
      }
    }
  }
  const resetForm = () => {
    setPostTitle("");
    setReference("");
    setAccountType("");
    setPostDescription("");
    setPostRequirement([]);
    setOfferType("");
    setPostDeadline("");
    setPostImage("");
    setSalary("");
    setNumPeople("");
  };

  const handleImageUpload = (postImage) => {
    setPostImage(postImage);
    setErrors((prev) => ({ ...prev, postImage: "" }));
  };

  const { showSnackbar } = useSnackbar();
  const handleSearch = () => {
    Load();
  };
  const deletePostById = async (postId) => {
    try {
      await axios.delete(`${apiUrl}posts/${postId}/delete/`);
      console.log(`Post with ID ${postId} has been deleted.`);
      Load();
      showSnackbar("Post deleted successfully", "success");
    } catch (error) {
      showSnackbar("Post can't deleted", "error");

      console.error(`Error deleting post with ID ${postId}: ${error.message}`);
    }
  };

  const updatePost = async (updatedData) => {
    try {
      console.log("it's been called here 2!!")
      const response = await axios.put(
        `${apiUrl}posts/${updatedData.postid}/update/`,
        {
          ...updatedData,
          recruiter_email: updatedData.recruiterEmail
        }
      );
      if (response.status === 200) {
        const updatedPost = response.data;

        setPosts(prevPosts =>
          prevPosts.map(post =>
            post.id === updatedData.postid ? { ...post, ...updatedPost } : post
          )
        );

        toast.success(t("postPage.success.postUpdated") || "Post updated successfully");
      }
    } catch (error) {
      console.error(`Error updating post: ${error.message}`);
      toast.error(t("postPage.errors.postUpdateFailed") || "Failed to update post");
    }
  };

  const handleSelectPost = (post) => {
    setSelectedPost(post);
  };

  const handleBackToList = () => {
    setSelectedPost(null);
  };
  // const handleSalaryChange = (e) => {
  //   const value = e.target.value;
  //   setSalary(value ? parseFloat(value) : null);
  //   console.log("salary value is :", salary);
  // };
  const handleSalaryChange = (value) => {
    setSalary(value ? parseFloat(value) : null);
    console.log("salary value is :", value);
  };

  const filteredCards = posts.filter((post) => {
    const job = post.title.toLowerCase();
    const filterLower = filter.toLowerCase();
    return job.startsWith(filterLower);
  });

  const onArchivePost = async (postId, archivedStatus) => {
    try {
      // If trying to de-archive, check the deadline first
      const post = posts.find((p) => p.id === postId);
      if (post && new Date(post.deadline) < new Date()) {
        toast.warning(
          "You need to change the deadline to de-archive this post."
        );
        return;
      }

      const response = await fetch(
        `${apiUrl}posts/${postId}/archive/${userId}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
          body: JSON.stringify({ archived: archivedStatus }),
        }
      );
      if (response.ok) {
        console.log(
          `Post with ID ${postId} has been ${archivedStatus ? "archived" : "unarchived"
          }.`
        );
        await Load();
        toast.success(
          `Post has been ${archivedStatus ? "archived" : "de-archived"
          } successfully.`
        );
      } else {
        console.error(
          `Error updating archive status for post with ID ${postId}: ${response.statusText}`
        );
        toast.error("Failed to update archive status.");
      }
    } catch (error) {
      console.error(`Error updating archive status: ${error.message}`);
      toast.error("An error occurred while updating archive status.");
    }
  };
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const handleCheckboxChangeScr = (event) => {
    setIsCheckedScr(true);
    console.log("new state ", isCheckedScr);
  };
  const [value, setValue] = useState([]);
  // if (loading) return <AnimatedLoading />;
  // if (error) return <div>Error: {error}</div>;

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="d-flex flex-column content">

        <Container>
          <>
            <Box sx={{ width: "100%" }}>
              {/* <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <TitleTypography>Posts</TitleTypography>
                  </Grid>

                  <Grid
                    item
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                    spacing={2}
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                      <Box
                        sx={{
                          backgroundColor: "#fff",
                          display: "flex",
                          alignItems: "center",
                          px: 1,
                          borderRadius: "10px",
                          width: "100%",
                        }}
                      >
                        <PostSearchBar
                          variant="outlined"
                          size="small"
                          type="text"
                          placeholder="Filter by Job post"
                          value={filter}
                          onChange={(e) => setFilter(e.target.value)}
                          sx={{ flex: 1, mr: 1 }}
                        />
                        <SearchButton
                          onClick={() => setOpen(true)}
                          variant="contained"
                          type="submit"
                        >
                          Search
                        </SearchButton>
                      </Box>
                    </Grid>*/}

              {/* <Grid item xs={12} sm="auto">
                      <PostButton
                        onClick={() => setOpen(true)}
                        variant="contained"
                        type="submit"
                        sx={{ width: { xs: "100%", sm: "auto" } }}
                      >
                        Add new Post
                      </PostButton>
                    </Grid> */}
              {/* </Grid>
                </Grid>  */}
              <NewSearchBar
                filter={filter}
                setFilter={setFilter}
                setOpen={setOpen}
                t={t}
                searchIcon={searchIcon}
                addIcon={addIcon}
                filterIcon={filterIcon}
                PostSearchBar={PostSearchBar}
                handleSearch={handleSearch}
                onFilterClick={() => setFilterDialogOpen(true)}
              />
              <FilterDialog
                open={filterDialogOpen}
                onClose={() => setFilterDialogOpen(false)}
                filters={filterOptions}
                setFilters={setFilterOptions}
                onApply={() => {
                  setFilterDialogOpen(false);
                  Load();
                }}
              />
            </Box>

            <Container fluid className="px-4">
              {/* <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: '2%' }}>
                    <FormControlLabel
                      control={
                        <ArchiveSwitch
                          checked={showAllPosts}
                          onChange={(e) => setShowAllPosts(e.target.checked)}
                        />
                      }
                      // label="Show Archived Posts"
                      sx={{ marginRight: "30px" }} // You can keep this or adjust it as needed
                    />
                  </Box> */}

              <Row className="g-4">
                {loading ? (
                  [...Array(6)].map((_, index) => (
                    <Col
                      key={`skeleton-${index}`}
                      xs={12}
                      sm={6}
                      md={4}
                      lg={4}
                      xl={4}
                      xxl={3}
                    >
                      <JobCardRecSkeleton />
                    </Col>
                  ))
                ) : posts && posts.length > 0 ? (
                  posts.map((post) => (
                    <Col key={post.id} xs={12} md={6} lg={4}>
                      <JobCardRec
                        job={post}
                        postid={post.id}
                        imageSrc={post.recruiter_image}
                        title={post.title}
                        description={post.description}
                        requirement={post.requirements}
                        deadline={post.deadline}
                        company={post.company}
                        onDeletePost={deletePostById}
                        updatePost={updatePost}
                        handleImageUpload={handleImageUpload}
                        archived={post.archived}
                        onArchivePost={onArchivePost}
                        onSelectPost={() => handlePostClick(post)}
                      />
                    </Col>
                  ))
                ) : (
                  ''
                )}
              </Row>
              {posts && posts.length > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                  <CustomPagination
                    page={page}
                    handleChangePage={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    count={totalPosts}
                  />
                </Box>
              )}
            </Container>
          </>
          <PostDetailsDialog
            setOpen={setOpen}
            postTitle={postTitle}
            setPostTitle={setPostTitle}
            reference={reference}
            setReference={setReference}
            recruiterEmail={recruiterEmail}
            setRecruiterEmail={setRecruiterEmail}
            setAccountType={setAccountType}
            accountType={accountType}
            postDescription={postDescription}
            setPostDescription={setPostDescription}
            offerType={offerType}
            setOfferType={setOfferType}
            postRequirement={postRequirement}
            setPostRequirement={setPostRequirement}
            postDeadline={postDeadline}
            handleDateChange={handleDateChange}
            handleNext={handleNext}
            open={open}
            errors={errors}
            showRef={ref}
            setErrors={setErrors}
          />
          <WorkingDetailsDialog
            setOpen2={setOpen2}
            setOpen={setOpen}
            open2={open2}
            errors={errors}
            handleImageUpload={handleImageUpload}
            setWorkingMode={setWorkingMode}
            workingMode={workingMode}
            location={location}
            setLocation={setLocation}
            setErrors={setErrors}
            numPeople={numPeople}
            setNumPeople={setNumPeople}
            salary={salary}
            handleSalaryChange={handleSalaryChange}
            currency={currency}
            setCurrency={setCurrency}
            isChecked={isChecked}
            handleCheckboxChange={handleCheckboxChange}
            isCheckedScr={isCheckedScr}
            handleCheckboxChangeScr={handleCheckboxChangeScr}
            handleSave={handleSave}
            fieldOfStudy={fieldOfStudy}
            setFieldOfStudy={setFieldOfStudy}
            otherFieldOfStudy={otherFieldOfStudy}
            setOtherFieldOfStudy={setOtherFieldOfStudy}
            experience={experience}
            setExperience={setExperience}
            diploma={diploma}
            setDiploma={setDiploma}
            otherDiploma={otherDiploma}
            setOtherDiploma={setOtherDiploma}
          />
        </Container>
        {/* )} */}
      </div>
    </ThemeProvider>
  );
};

export default PostPage;
